// components/customer/CustomerNotesSection.jsx
import { useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";

// Import reusable components
import FormCard from "@/components/formInputFields/FormCard";
import FormSectionTitle from "@/components/formInputFields/FormSectionTitle";
import CustomerNoteModal from "./CustomerNoteModal";

// Import inhouse icons
import { Pencil } from "lucide-react";

export default function CustomerNotesSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { control } = useFormContext();

  const note = useWatch({ control, name: "notes" });
  const hasNote = note?.trim()?.length > 0;

  return (
    <>
      <FormCard className="w-full max-w-xs h-fit relative">
        <div className="flex flex-row items-center justify-between mb-4">
            <span className="text-[15px] font-semibold text-[#000]">Notes</span>
        
            <button
              type="button"
              onClick={() => setIsModalOpen(true)}
              className=""
              aria-label="Edit note"
            >
              <Pencil className="h-4 w-4 text-[#333333]" />
            </button>
        </div>
        
        <p className="text-sm text-[#333333] whitespace-pre-wrap">
          {hasNote
            ? note
            : "Notes are private and won't be shared with the customer."}
        </p>
      </FormCard>

      {isModalOpen && (
        <CustomerNoteModal
          initialNote={note}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};